import CitySEOHead from "@/components/feature/CitySEOHead";
import OFallonHeroSection from "./components/HeroSection";
import OFallonStickyNav from "./components/StickyNav";
import OFallonProcessingTimeSection from "./components/ProcessingTimeSection";
import OFallonServicesSection from "./components/ServicesSection";
import OFallonLocalAreaSection from "./components/LocalAreaSection";
import OFallonDestinationsSection from "./components/DestinationsSection";
import OFallonTestimonialsSection from "./components/TestimonialsSection";
import OFallonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import OFallonComparisonSection from "./components/ComparisonSection";
import OFallonMistakesSection from "./components/MistakesSection";
import OFallonHowItWorksSection from "./components/HowItWorksSection";
import OFallonFAQSection, { faqs } from "./components/FAQSection";
import OFallonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import OFallonFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function OFallonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="O'Fallon"
        state="Missouri"
        stateAbbr="MO"
        route="/cities/ofallon-mo"
        title="Emergency Passport O'Fallon, MO — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in O'Fallon, MO — as fast as 24 hours. Military families near Scott AFB, tech professionals, and St. Charles County families. A+ BBB rated, registered State Dept. courier. No drive to Downtown St. Louis required."
        geoPlacename="O'Fallon, Missouri"
        geoPosition="38.8112;-90.6998"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Missouri"
        statePageRoute="/states/missouri"
      />
      <OFallonHeroSection />
      <OFallonStickyNav />
      <OFallonProcessingTimeSection />
      <OFallonServicesSection />
      <OFallonLocalAreaSection />
      <OFallonDestinationsSection />
      <OFallonTestimonialsSection />
      <OFallonAcceptanceFacilitiesSection />
      <OFallonComparisonSection />
      <OFallonMistakesSection />
      <OFallonHowItWorksSection />
      <OFallonFAQSection />
      <OFallonHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/ofallon-mo" state="MO" />
      <OFallonFinalCTA />
    </div>
  );
}